export const POKER_CHIP_DENOMINATIONS = [
  { value: 500, face: "#71458a", edge: "#442353", accent: "#f4e5bb" },
  { value: 100, face: "#292b2d", edge: "#080909", accent: "#f4e5bb" },
  { value: 25, face: "#2b5595", edge: "#17396c", accent: "#f4e5bb" },
  { value: 5, face: "#a82d35", edge: "#7a1821", accent: "#f4e5bb" },
  { value: 1, face: "#e5dfcf", edge: "#9a917d", accent: "#34312c" },
] as const;

export type PokerChipDenomination = typeof POKER_CHIP_DENOMINATIONS[number];
export interface PokerChipStack { denomination: PokerChipDenomination; count: number }

/** Convert a whole-chip value into the smallest exact set of casino chips. */
export function pokerChipStacks(amount: number, maximumStackHeight = 20): PokerChipStack[] {
  let remainder = Math.max(0, Math.round(amount));
  const stackHeight = Math.max(1, Math.floor(maximumStackHeight));
  const stacks: PokerChipStack[] = [];
  for (const denomination of POKER_CHIP_DENOMINATIONS) {
    let count = Math.floor(remainder / denomination.value);
    remainder -= count * denomination.value;
    while (count > 0) {
      const inStack = Math.min(stackHeight, count);
      stacks.push({ denomination, count: inStack }); count -= inStack;
    }
  }
  return stacks;
}

export const pokerChipCount = (amount: number) => pokerChipStacks(amount).reduce((total, stack) => total + stack.count, 0);
export const pokerStackValue = (stacks: readonly PokerChipStack[]) => stacks.reduce((total, stack) => total + stack.denomination.value * stack.count, 0);
